import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=083a840c&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083a840c')) {
      api.createRecord('083a840c', component.options)
    } else {
      api.reload('083a840c', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=083a840c&", function () {
      api.rerender('083a840c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Jagty6meKdP/JS/comp/openstreetmap.vue"
export default component.exports